import { getApiData } from "../utils/APIHelper";

const ENDPOINTS = {
  BY_PROJECT: (projectId) => `api/renders/project/${projectId}`,
};

export const getRendersByProject = async (projectId) => {
  try {
    return await getApiData(ENDPOINTS.BY_PROJECT(projectId), "GET", {});
  } catch (error) {
    console.error("Get renders error:", error);
    throw error;
  }
};
